export default "__VITE_ASSET__96b4fcd5__"